export default __webpack_public_path__ + "static/communication2-ac9b868e370b2eb4ce8ebb1c551ac77e.webp";